import PersistentCheckboxSelectAll from "./persistent_checkbox_select_all_controller";

// Connects to data-controller="participants-select"
export default class extends PersistentCheckboxSelectAll {
  static targets = ["actionButton", "count"];

  connect() {
    super.connect();
    this.updateUI();
  }

  refresh() {
    requestAnimationFrame(() => {
      this.updateUI();
    });
  }

  updateUI() {
    const selectedCount = this.checkboxTargets.filter(
      (cb) => cb.checked,
    ).length;

    this.actionButtonTargets.forEach((btn) => {
      btn.classList.toggle("hidden!", selectedCount === 0);
    });

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${selectedCount} selected`;
      this.countTarget.classList.toggle("hidden!", selectedCount === 0);
    }
  }
}
